var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGamelogo6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "j1c5a1by6a",
    d: "M0 0.042L20 0.042 20 14 0 14z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-408 -190) translate(408 189) translate(0 .958)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "aursquvqeb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j1c5a1by6a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4B34FB",
    d: "M14.859.042H5.145c-1.895 0-3.513 1.37-3.824 3.24L.036 10.99C-.227 12.566.988 14 2.592 14h.059c.937 0 1.795-.53 2.215-1.367l1.44-2.872c.127-.254.387-.413.67-.413h6.054c.283 0 .543.16.67.414l1.355 2.712c.452.902 1.36 1.526 2.366 1.526h.05c1.57-.034 2.752-1.451 2.493-3.007l-1.28-7.71c-.31-1.87-1.93-3.241-3.825-3.241m0 1c1.413 0 2.606 1.012 2.839 2.406l1.28 7.709c.076.46-.046.91-.344 1.27-.293.354-.724.563-1.213.573-.598 0-1.175-.382-1.471-.974l-1.356-2.712c-.298-.596-.898-.966-1.564-.966H6.976c-.666 0-1.264.369-1.563.965l-1.441 2.872c-.252.503-.76.815-1.321.815h-.06c-.47 0-.913-.205-1.215-.562-.301-.355-.43-.823-.354-1.282l1.285-7.71c.233-1.393 1.426-2.404 2.838-2.404h9.714",
    mask: "url(#aursquvqeb)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4B34FB",
    d: "M6.505 6.816c-.643 0-1.163-.521-1.163-1.163 0-.643.52-1.163 1.163-1.163s1.163.52 1.163 1.163c0 .642-.52 1.163-1.163 1.163M13.485 6.816c-.643 0-1.163-.521-1.163-1.163 0-.643.52-1.163 1.163-1.163s1.163.52 1.163 1.163c0 .642-.52 1.163-1.163 1.163",
    transform: "translate(-408 -190) translate(408 189)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamelogo6);
export default __webpack_public_path__ + "static/media/gamelogo6.f099b7fb3fbcd9c410f753c6ff2fe876.svg";
export { ForwardRef as ReactComponent };